import React from 'react'
import NewsManagementTab from './NewsManagementTab'
import { NEWS_REVIEW_STATUS } from '../../../constants/newsReviewStatus'

const StrategicallyRejectedTab = ({ showNotification }) => {
  return (
    <NewsManagementTab
      showNotification={showNotification}
      fixedStatus={NEWS_REVIEW_STATUS.AUTO_REJECTED}
    />
  )
}

export default StrategicallyRejectedTab
